// extracted by mini-css-extract-plugin
export var modalFooter = "_sf-0";